import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { ListPaymentMethodResponse } from '~types';

type Options = {
  enabled?: boolean;
};

export const useQueryGetUserPaymentMethods = ({
  enabled = true,
}: Options = {}) => {
  return useQuery<ListPaymentMethodResponse>(
    [QUERY_KEY.GET_USER_PAYMENT_METHODS],
    () => {
      return getRequest<ListPaymentMethodResponse>({
        path: 'api/payment/payment-methods',
      });
    },
    {
      enabled: enabled && !!inMemoryJWTService.getCurrentToken(),
    },
  );
};
